import PropTypes from 'prop-types';

const TopActionBar = ({ leftContent, rightContent, containerClassName }) => {
  return (
    <>
      <div
        className={`flex justify-between min-h-[57px] items-center bg-[#151C2E] md:px-3 pb-1 md:py-1 px-1 pt-1 md:rounded-lg md:mb-3 mb-2 ${containerClassName}`}
      >
        <div className=" p-2">{leftContent}</div>
        <div>{rightContent}</div>
      </div>
    </>
  );
};

TopActionBar.defaultProps = {
  leftContent: <></>,
  rightContent: <></>,
  containerClassName: '',
};

TopActionBar.propTypes = {
  leftContent: PropTypes.node,
  rightContent: PropTypes.node,
  containerClassName: PropTypes.string,
};

export default TopActionBar;
